import actionTypes from '../../../redux/actions/action-types';

export const setAction = (data) => ({
  type: actionTypes.teamGroupsPage.set,
  data,
});

export const getPermissionsAction = (data) => ({
  type: actionTypes.teamGroupsPage.getPermissions,
  data,
});

export const getGroupPermissionsAction = (data) => ({
  type: actionTypes.teamGroupsPage.getGroupPermissions,
  data,
});

export const setGroupAction = (data) => ({
  type: actionTypes.teamGroupsPage.setGroup,
  data,
});

export const updateGroupAction = (data) => ({
  type: actionTypes.teamGroupsPage.updateGroup,
  data,
});

export const deleteGroupAction = (data) => ({
  type: actionTypes.teamGroupsPage.deleteGroup,
  data,
});

export const setGroupPermissionsAction = (data) => ({
  type: actionTypes.teamGroupsPage.setGroupPermissions,
  data,
});
